import { BookOpenTextIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, DicesIcon, FileTextIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShapesIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
// Caja 3D transparente de los 6 dílů (Recursos de la tienda 162045d9).
export const PRODUCT_IMAGE = 'https://sb.impultienda.ar/storage/v1/object/public/store-resources/162045d9-ccb4-4d79-90f0-3cd3528f3f43/1793726498086_judohotove-caja-6-dilu-transparente-e353d563.webp';
export const heroGuarantees = ['Okamžitě ke stažení', 'Jednorázová platba', 'Žádné předplatné', '7denní záruka spokojenosti'];
export const stats = [{
  value: '240',
  label: 'Stran v šesti dílech'
}, {
  value: '6',
  label: 'Digitálních dílů dětského juda'
}, {
  value: '3',
  label: 'Věkové skupiny – 4 až 15 let'
}, {
  value: '5',
  label: 'Bonusů v ceně'
}, {
  value: '1',
  label: 'Kompletní systém na tatami'
}];
export const differenceStats = [{
  value: '4–15 let',
  label: 'Od předžáků po starší žáky, ve třech věkových skupinách'
}, {
  value: '6 digitálních dílů',
  label: 'Od ročního plánu po zkoušku na pásek'
}, {
  value: 'PDF k tisku',
  label: 'Na tabletu nebo vytištěné – rovnou s sebou na tatami'
}];
export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Přijdete o nedělní večer',
  text: 'Hodiny u notebooku nad přípravou tréninků na celý týden – a pořád to není hotové.'
}, {
  title: 'Hodiny hledání',
  text: 'Hry z internetu jsou moc lehké, moc těžké nebo neodpovídají věku vaší skupiny.'
}, {
  title: 'Každý trénink od nuly',
  text: 'Rozcvička, pády, technika, hra, závěrečné protažení – co by mělo zabrat pár minut, se mění v samostatnou práci.'
}, {
  title: 'Různé úrovně v jedné skupině',
  text: 'Bílé a zelené pásky na jednom tatami: někdo se vždycky nudí.'
}, {
  title: 'Sledování a zkoušky na pásek berou čas',
  text: 'Karty pokroku, program pásků, zprávy rodičům – další práce po tréninku.'
}, {
  title: 'Stres před tréninkem',
  text: 'Když chybí čas, improvizujete a trénink vymýšlíte na poslední chvíli u tatami.'
}];
export const afterItems = ['Přehledný balíček juda pro děti od 4 do 15 let', 'Tréninky minutu po minutě, snadno k použití', 'Karty tréninků, které hned vytisknete', '100 hotových her a úpolových cvičení pro judo', 'Technika krok za krokem a program pásků', '3 úrovně na jednom tatami', 'Jasná bezpečnostní pravidla: žádné páky a žádná škrcení', 'Karty pokroku a zkoušky na pásek připravené', 'Plán na celou sezónu – od září do června'];
export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Víkendy plné přípravy',
  text: 'Trávíte část víkendu přípravou tréninků juda na další týden?'
}, {
  icon: FolderSearchIcon,
  title: 'Nevíte, jakou hru vybrat',
  text: 'Pořád hledáte hry a úpolová cvičení, která odpovídají věku vašich judistů?'
}, {
  icon: LightbulbIcon,
  title: 'Chcete vysvětlovat srozumitelněji',
  text: 'Potřebujete ilustrace a kroky, abyste dětem techniku vysvětlili jednoduše?'
}, {
  icon: PencilRulerIcon,
  title: 'Chcete přestat všechno vymýšlet sami',
  text: 'Chcete mít tréninky, hry a karty tréninků připravené předem?'
}, {
  icon: ShuffleIcon,
  title: 'Vaši judisté potřebují pestrost',
  text: 'Chcete víc her, úpolových forem a výzev, aby celá skupina zůstala zapojená?'
}, {
  icon: LayoutGridIcon,
  title: 'Potřebujete jasnou strukturu',
  text: 'Chcete mít všechen materiál přehledně pohromadě a rychle najít, co potřebujete?'
}];

// Spine colours mirror the physical box (blue, light blue, green, yellow, orange, red).
export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Díl 01',
  level: '4–15 let',
  title: 'Roční plán a 12 tréninků',
  tagline: 'Celá sezóna zorganizovaná, měsíc po měsíci.',
  intro: 'První díl obsahuje roční plán pro tři věkové skupiny a 12 kompletních tréninků minutu po minutě.',
  items: ['Roční plán 4–7, 8–11 a 12–15 let', 'Týden s 1, 2 nebo 3 tréninky', 'Stavba tréninku na 45 a 60 minut', '3 úrovně na jednom tatami', '12 tréninků minutu po minutě', 'Karty tréninků k tisku', 'Plánek tatami a stanoviště', 'Bezpečnost a kontrolní seznam', 'Karta pokroku skupiny'],
  outro: 'Vstoupíte na tatami a přesně víte, co budete dělat.',
  spine: 'bg-blue-700 text-white',
  rule: 'border-white/30'
}, {
  number: 'Díl 02',
  level: '4–15 let',
  title: 'Banka tréninků: 50 hotových tréninků',
  tagline: 'Na každou situaci jeden trénink.',
  intro: 'Druhý díl obsahuje 50 hotových tréninků seřazených podle témat a věkových skupin.',
  items: ['Stavba na 30, 45 a 60 minut', '8 tréninků pro nejmenší', 'Pády', 'Boj na zemi a držení', 'Hody', 'Hry a kondice', 'Před zkouškou na pásek', 'Před turnajem', 'Ukázkové hodiny pro rodiče'],
  outro: 'Vybrat, vytisknout, trénovat.',
  spine: 'bg-sky-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Díl 03',
  level: '4–15 let',
  title: '100 her a úpolových cvičení pro judo',
  tagline: 'Děti, které si hrají, se učí a vracejí se.',
  intro: 'Třetí díl obsahuje 100 her seřazených podle cíle a věku, s pravidly, variantami a bezpečností.',
  items: ['20 her na rozcvičku', '16 her na pády', '16 úpolových her v postoji', '16 her na zemi', '16 her pro nejmenší', '16 týmových her', 'Tréninky ze 100 % hrou', 'Hry pro malý prostor', 'Vymyslete si vlastní hru'],
  outro: 'Radost z juda bez přípravy.',
  spine: 'bg-green-600 text-white',
  rule: 'border-white/30'
}, {
  number: 'Díl 04',
  level: '4–15 let',
  title: 'Technika krok za krokem a pásky',
  tagline: 'Každá technika jednoduše vysvětlená.',
  intro: 'Čtvrtý díl ukazuje techniky krok za krokem, s programem pásků od bílého po hnědý.',
  items: ['Pády (ukemi)', '4 držení a vyprostění', '10 hodů pro děti', 'Kuzuši a pohyb', 'Program od 6. do 1. kyu (od bílého po hnědý)', 'Karty technik k tisku', 'Časté chyby a opravy', 'Postup podle úrovně'],
  outro: 'Bezpečné techniky přizpůsobené každému věku.',
  spine: 'bg-yellow-400 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Díl 05',
  level: '4–15 let',
  title: 'Bezpečnost, skupina a rodiče',
  tagline: 'Klidná skupina, spokojení rodiče.',
  intro: 'Pátý díl vám pomůže s bezpečností, kázní ve skupině a komunikací s rodiči.',
  items: ['Bezpečnostní pravidla na tatami', 'První pomoc a zranění', 'Vedení skupiny a rituály', 'Problémové nebo stydlivé děti', 'Komunikace s rodiči', 'Schůzka s rodiči', 'Organizace sezóny', 'Kontrolní seznamy'],
  outro: 'Víc klidu, trénink za tréninkem.',
  spine: 'bg-orange-500 text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Díl 06',
  level: '4–15 let',
  title: 'Pokrok, testy a zkoušky na pásky',
  tagline: 'Sledujte, jak každý judista roste.',
  intro: 'Šestý díl obsahuje hodnoticí formuláře, fyzické testy a vše pro organizaci zkoušek na pásky v oddílu.',
  items: ['Karty pokroku', 'Fyzické testy podle věku', 'Hodnoticí formuláře', 'Program zkoušek na pásky', 'Zkušební formuláře k tisku', 'Diplomy', 'Hodnocení sezóny', 'Sledování skupiny'],
  outro: 'Viditelný pokrok pro děti i rodiče.',
  note: 'Tento materiál není oficiální publikací Českého svazu juda (ČSJu).',
  spine: 'bg-red-600 text-white',
  rule: 'border-white/30'
}];
export const volumesIntro = {
  title: '6 digitálních dílů pro děti od 4 do 15 let',
  text: 'Kompletní balíček dětského juda, se kterým připravíte a odvedete tréninky celé sezóny. Každý díl má 40 stran s tréninky, hrami, kartami a aktivitami na tatami.'
};
export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Hotové tréninky',
  text: 'Žádný prázdný papír. Tréninky minutu po minutě i se slovy trenéra – můžete hned začít.'
}, {
  icon: FileTextIcon,
  title: 'Karty tréninků k tisku',
  text: 'Karty tréninků, karty pokroku a zkušební formuláře k vytištění a s sebou na tatami.'
}, {
  icon: ShapesIcon,
  title: 'Srozumitelné ilustrace',
  text: 'Ilustrace, kroky a krátké pokyny, které jasně vysvětlí každou techniku i hru.'
}, {
  icon: DicesIcon,
  title: 'Hry a úpolová cvičení',
  text: 'Rozcvičky, hry na pády a úpolové formy, které zapojí celou skupinu.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Zkoušky na pásek bez stresu',
  text: 'Program pásků, zkušební formuláře, fyzické testy a karty pokroku.'
}, {
  icon: CalendarCheckIcon,
  title: 'Plán na celou sezónu',
  text: 'Od září do června: témata, cíle a oddílové akce na každý měsíc, od Mikuláše po přebor oddílu.'
}];
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/162045d9-ccb4-4d79-90f0-3cd3528f3f43/1793745083705_judohotove-dil01-p01-8b9cbb78.webp",
    "label": "Díl 01 · Strana 1",
    "title": "Obálka",
    "text": "Roční plán a 12 tréninků minutu po minutě."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/162045d9-ccb4-4d79-90f0-3cd3528f3f43/1793745094212_judohotove-dil01-p04-af207fea.webp",
    "label": "Roční plán · Strana 4",
    "title": "Roční plán pro předžáky a nejmenší 4–7 let",
    "text": "Téma, cíl a oddílová akce na každý měsíc, od září do června."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/162045d9-ccb4-4d79-90f0-3cd3528f3f43/1793745104509_judohotove-dil01-p10-95f1e834.webp",
    "label": "Tréninky · Strana 10",
    "title": "Trénink 1 · První den na tatami",
    "text": "Minutu po minutě: pozdrav, hra na rozcvičku, pády, technika a úpolové hry."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/162045d9-ccb4-4d79-90f0-3cd3528f3f43/1793745115664_judohotove-dil01-p22-e8d1adc7.webp",
    "label": "Tréninky · Strana 22",
    "title": "Trénink 7 · První hod: o-goši",
    "text": "Cíl, pomůcky a tipy trenéra na jedné stránce."
  },
  {
    "src": "https://sb.impultienda.ar/storage/v1/object/public/store-resources/162045d9-ccb4-4d79-90f0-3cd3528f3f43/1793745125652_judohotove-dil01-p35-d6af0348.webp",
    "label": "Bezpečnost · Strana 35",
    "title": "Bezpečnost na tatami",
    "text": "10 jasných pravidel, aby každý trénink bezpečně začal i skončil."
  }

];
export const pageTypes = ['Tréninky', 'Karty tréninků k tisku', 'Hry a úpolová cvičení', 'Zkoušky na pásek'];
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Zástup bez stresu – 12 hotových tréninků pro asistenta',
  text: 'Skupina trénuje dál, i když vy nemůžete přijít.',
  items: ['Předávací formulář', '12 hotových tréninků', '4 pro každou věkovou skupinu', 'Docházková listina'],
  benefit: 'Odejdete s klidnou hlavou: trénink pokračuje.'
}, {
  title: 'Rozcvičky na judo za 5 minut – 60 karet k tisku',
  text: '60 karet k tisku, se kterými za pět minut sestavíte rozcvičku.',
  items: ['Honičky', 'Pády a kotouly', 'Hry ve dvojicích', '5 hotových rozcviček'],
  benefit: 'Na každém tréninku jiná rozcvička.'
}, {
  title: 'Oddílový turnaj a den otevřených dveří krok za krokem',
  text: 'Vše pro uspořádání dětského turnaje a dne otevřených dveří bez chaosu.',
  items: ['Plán na 6 týdnů', 'Turnajové pavouky', 'Diplomy k tisku', 'Ukázková hodina pro rodiče'],
  benefit: 'Vydařená akce bez stresu.'
}, {
  title: 'Komunikace s rodiči – 40 hotových zpráv',
  text: 'Hotové zprávy na celou sezónu – stačí je zkopírovat a odeslat.',
  items: ['Přihláška a začátek sezóny', 'Zkouška na pásek a turnaje', 'Zrušený trénink', 'Schůzka s rodiči a časté otázky'],
  benefit: 'Informovaní a spokojení rodiče.'
}, {
  title: 'Plakáty do dojo – 15 plakátů k tisku',
  text: 'Barevné plakáty, které organizují trénink a předávají hodnoty juda.',
  items: ['Pravidla tatami', 'Čtyři techniky pádů', 'Osm hodnot juda', 'Barvy pásků'],
  benefit: 'Dojo, které učí, i když zrovna mluvíte vy.'
}];
export const steps: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Otevřete JUDO HOTOVÉ™',
  text: 'Stáhněte si balíček a otevřete díl, který tento týden potřebujete.'
}, {
  title: 'Vyberte trénink',
  text: 'Najděte měsíc a téma a vyberte trénink nebo hru pro svou skupinu.'
}, {
  title: 'Hotovo za 5 minut',
  text: 'Projděte si trénink minutu po minutě a připravte pomůcky.'
}, {
  title: 'Vytisknout a na tatami',
  text: 'Vytiskněte kartu tréninku nebo ji otevřete na tabletu – a jděte na tatami s jasným plánem.'
}];
export const audienceItems = ['Trénujete judo s dětmi ve věku 4–7, 8–11 nebo 12–15 let', 'Chcete mít celou sezónu juda zorganizovanou', 'Nechcete každý trénink vymýšlet znovu', 'Máte na jednom tatami různé úrovně', 'Hledáte bezpečné hry a úpolová cvičení', 'Chcete mít karty pokroku a zkoušky na pásek připravené', 'Chcete každý týden ušetřit čas', 'Chcete se na každý trénink cítit připravení'];
export const timeValueTasks = ['Hledání her', 'Sepisování tréninků', 'Příprava stanovišť a pomůcek', 'Organizace zkoušek na pásek', 'Sledování pokroku a psaní rodičům'];
export const offerRows: Array<{
  label: string;
  detail: string;
}> = [{
  label: '6 digitálních dílů – 240 stran',
  detail: 'Roční plán, tréninky, hry, technika, bezpečnost a zkoušky na pásek'
}, {
  label: '5 bonusů bez příplatku',
  detail: 'Zástup, rozcvičky, turnaj, zprávy rodičům a plakáty'
}, {
  label: 'Pro děti od 4 do 15 let',
  detail: 'Hotové tréninky, karty k tisku a sledování pokroku'
}];
export const offerIncludes = ['Okamžitě ke stažení', 'Soubory PDF k uložení', 'Karty tréninků k tisku', 'Nezasíláme žádný fyzický produkt'];
export const PRICE = '490 Kč';
export const COMPARE_PRICE = '1 990 Kč';

// Only add authentic reviews of JUDO HOTOVÉ. The section stays hidden while empty.
export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];
export const faqs = [{
  q: 'Jak materiál obdržím?',
  a: 'JUDO HOTOVÉ™ je digitální produkt. Po nákupu získáte přístup k souborům PDF, které si můžete stáhnout a uložit. Používáte je na počítači, tabletu nebo telefonu a vytisknete si karty, které potřebujete.'
}, {
  q: 'Hodí se JUDO HOTOVÉ™ pro české dětské judo?',
  a: 'Ano. Materiál je vytvořený pro trenéry juda v českých oddílech a judo klubech, s barvami pásků od bílého po hnědý (6. až 1. kyu) a s prostorem pro zkoušky na pásek ve vašem oddílu. Jde o nezávislý tréninkový materiál – tento materiál není oficiální publikací Českého svazu juda (ČSJu).'
}, {
  q: 'Je vhodný pro děti od 4 do 15 let?',
  a: 'Ano. Tréninky jsou rozdělené do tří věkových skupin (předžáci a nejmenší 4–7, mladší žáci 8–11 a starší žáci 12–15 let) a každý trénink má tři úrovně. Vybíráte podle věku a zkušeností své skupiny.'
}, {
  q: 'Je to pro děti bezpečné?',
  a: 'Ano. Pády jsou vždy na prvním místě, každý trénink má rámeček bezpečnost a s dětmi se nikdy necvičí páky ani škrcení.'
}, {
  q: 'Opravdu připravím trénink za 5 minut?',
  a: 'JUDO HOTOVÉ™ je vytvořené tak, aby vaši přípravu zrychlilo. Otevřete díl, vyberete hotový trénink a projdete ho přibližně za pět minut. Čas se může lišit podle skupiny a úprav, které uděláte.'
}, {
  q: 'Budu mít dost materiálu na celou sezónu?',
  a: 'Ano. Šest dílů pokrývá celou sezónu, od září do června. Tréninky vybíráte, kombinujete a přizpůsobujete vlastnímu plánu a skupině.'
}, {
  q: 'Jsou součástí i karty k tisku?',
  a: 'Ano. Balíček obsahuje karty tréninků, karty technik, karty pokroku, zkušební formuláře a diplomy k tisku.'
}, {
  q: 'Můžu pracovat s judisty různých úrovní?',
  a: 'Ano. Každý trénink má tři úrovně, takže začátečníci i pokročilí cvičí na jednom tatami, každý na své úrovni.'
}, {
  q: 'Musím všechno tisknout?',
  a: 'Ne. Vytisknete jen stránky, které potřebujete; zbytek si prohlédnete na tabletu nebo telefonu u tatami.'
}, {
  q: 'Je všech pět bonusů v ceně?',
  a: `Ano. Všech pět bonusů je v balíčku bez příplatku – vše dohromady za ${PRICE}.`
}, {
  q: 'Je to předplatné?',
  a: 'Ne. Zaplatíte jednou a získáte přístup k digitálnímu materiálu. Bez opakovaných plateb.'
}, {
  q: 'Můžu si soubory uložit?',
  a: 'Ano. Soubory PDF si můžete stáhnout a uložit v souladu s podmínkami užívání produktu.'
}, {
  q: 'Můžu ho používat na telefonu nebo tabletu?',
  a: 'Ano. PDF otevřete na počítači, tabletu i telefonu. Pro kontrolu rozvržení před tiskem doporučujeme počítač nebo tablet.'
}, {
  q: 'Je k dispozici záruka?',
  a: 'Ano. JUDO HOTOVÉ™ má 7denní záruku spokojenosti. Pokud materiál nesplní vaše očekávání, pošlete nám během záruční lhůty e-mail a požádejte o vrácení peněz, v souladu s podmínkami.'
}];
export const footerLinks = ['Obchodní podmínky', 'Ochrana osobních údajů', 'Vrácení peněz', 'Kontakt'];
